import clsx from "clsx";
import type { CaseTab } from "@/lib/types";
import styles from "./styles.module.scss";

interface Props {
  selectedTab: CaseTab;
  setSelectedTab: (tab: CaseTab) => void;
}

export default function CaseTabs(props: Props) {
  return (
    <div className={"d-flex justify-content-start mb-4"}>
      <button
        data-testid="discovery-tab"
        type="button"
        className={clsx(
          "bg-white",
          styles.tab,
          props.selectedTab === "discovery" && styles.active,
        )}
        onClick={() => props.setSelectedTab("discovery")}
      >
        Discovery
      </button>
      <button
        data-testid="production-tab"
        type="button"
        className={clsx(
          "bg-white",
          styles.tab,
          props.selectedTab === "production" && styles.active,
        )}
        onClick={() => props.setSelectedTab("production")}
      >
        Production
      </button>

      <div className={`${styles.bottomLine} w-100`} />
    </div>
  );
}
